import React, { ComponentPropsWithoutRef, FC } from 'react';
import cn from 'classnames';
import { ReactComponent as Arrows } from '../../icons/select.svg';
import { usePopupContext } from '../../contexts/Settings';
import { isGridLayout, popupLayoutCssPostfix } from '../../types';

interface Props extends ComponentPropsWithoutRef<'select'> {
  className?: string;
}

const Select: FC<Props> = ({ children, className = '', ...props }) => {
  const { settings } = usePopupContext();
  const popupLayoutCssPostfixValue: string = popupLayoutCssPostfix(settings);

  return (
    <div
      className={cn(
        className,
        'w-full relative',
        `Select-Variant--wrapper${popupLayoutCssPostfixValue}`,
        `${isGridLayout(settings) ? '' : 'md:w-250'}`,
        props.disabled ? 'text-grey-3' : 'text-grey-1',
      )}
    >
      <Arrows
        className={`right-8 absolute top-half transform -translate-y-1/2 pointer-events-none
         Select-Variant--icon${popupLayoutCssPostfixValue}`}
      />
      <select
        className={cn(
          className,
          'appearance-none py-8 px-10 bg-white text-md w-full border bg-no-repeat pointer:text-md-mobile pr-25 truncate',
          props.disabled ? 'cursor-default border-grey-4' : 'cursor-pointer',
        )}
        {...props}
      >
        {children}
      </select>
    </div>
  );
};

export default Select;
